import lowerCase from 'lodash/lowerCase';
import { Promotion, PricingType, CycleInterval, BillingFrequency } from '@css-xp/graphtypes';

enum PromotionType {
  TRIAL_EXTENSION = 'TRIAL_EXTENSION',
}

export const getAppropriatePaidPromotions = (promotions: any, cycleInterval: CycleInterval) => {
  return (
    promotions?.filter((promotion: Promotion) => {
      // Note: The `.includes` method check is case-sensitive
      const isPaid = promotion?.pricingType?.includes(PricingType.PAID);
      const hasCorrectCycleInterval = promotion?.cycleInterval?.includes(cycleInterval);

      //Trial types are not showing for changing subscription, add promotion and reactivation sub
      const isTrialType = promotion?.type !== PromotionType.TRIAL_EXTENSION;

      return isPaid && hasCorrectCycleInterval && isTrialType;
    }) ?? []
  );
};

export const getAppropriatePromotions = (
  promotions: any,
  billingFrequency: BillingFrequency | string | null | undefined
) => {
  // Default `billingFrequency` to `BillingFrequency.MONTHLY` as the new
  // entitlements (Public Trial, Private Trial, etc.) will have it as null.
  // (So, this will display monthly promotions for such cases)
  const billFrequency = billingFrequency || BillingFrequency.MONTHLY;
  const isAnnualPlan = lowerCase(billFrequency ?? '') === lowerCase(BillingFrequency.ANNUAL);
  const isMonthlyPlan = lowerCase(billFrequency ?? '') === lowerCase(BillingFrequency.MONTHLY);

  if (isMonthlyPlan) {
    return getAppropriatePaidPromotions(promotions, CycleInterval.MONTH);
  } else if (isAnnualPlan) {
    return getAppropriatePaidPromotions(promotions, CycleInterval.YEAR);
  } else {
    return [];
  }
};
